import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { timeAgo } from '../../../shared/utils/date-utils';
import { Router } from '@angular/router';

@Component({
  selector: 'app-favorites',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './favorites.component.html',
  styleUrl: './favorites.component.scss'
})
export class FavoritesComponent {

  private api = inject(ApiService);
  private router = inject(Router);
  favorites: any[] = [];

  ngOnInit() {
    this.loadFavorites();
  }

  loadFavorites() {
    const userData = JSON.parse(localStorage.getItem('userData') || '{}');
    const userId = userData?.user_id;
    this.api.get<any>(`/favorites/${userId}`).subscribe({
      next: (res) => {
        this.favorites = res
        .sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
        .slice(0, 3)
        .map((fav: any) => ({
            _id: fav.refId,
            type: fav.type,
            application: fav.project?.name || 'General',
            title: fav.title,
            uploaded: timeAgo(fav.createdAt),
            moduleSlug: this.slugify(fav.project?.name || 'general'),
          }));
      },
      error: (err) => {
        console.error('Error loading favorites:', err);
      },
    });
  }

  slugify(name: string): string {
    return name.toLowerCase().replace(/\s+/g, '-');
  }

  openVideo(item: any) {
    if (item.type === 'video') {
      this.router.navigate(['/content', item.moduleSlug, 'video', item._id]);
    } else if (item.type === 'document') {
      this.router.navigate(['/content', item.moduleSlug, 'document', item._id]);
    } else {
      console.warn('Unknown type:', item.type);
    }
  }
}
